module.exports = __webpack_public_path__ + "img/e-Latih.eecc999b.jpg";